import React from 'react';
import { useTranslation } from 'next-i18next';
import Router from 'next/router';
import { filter } from 'lodash';
import { useRouter } from 'next/router';
import { useWebshopState } from '@context/webshop';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

function IndexPage() {
  const { t } = useTranslation('webshop');
  const router = useRouter();
  const { id } = router.query;
  const { webShop, fetchWebshop, fetchUserCart } = useWebshopState();

  const goToHome = () => {
    Router.push({
      pathname: `/${id}`,
    });
  };

  React.useEffect(() => {
    const { id } = router.query;
    if (id) {
      fetchWebshop(id);
      if (filter(JSON.parse(localStorage.getItem('userData')), { webShopToken: id }).length > 0) {
        const userData = filter(JSON.parse(localStorage.getItem('userData')), { webShopToken: id })[0];
        fetchUserCart({
          webShopToken: id,
          userId: userData.userId,
        });
      }
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="container my-24 px-6 mx-auto">
      <section className="mb-32 text-gray-800 text-center">
        <div className="px-6 py-12 md:px-12">
          <h2 className="text-5xl my-12 font-bold tracking-tight">{t('webshop.CONTACT_SUPPORT')}</h2>
          <p className="lead text-muted">{t('webshop.QUESTION_PASSES')}</p>
        </div>
        {webShop && webShop.webShopContact && (
          <div className="flex justify-center">
            <div className="block p-6 rounded-lg shadow-lg bg-white max-w-sm w-[400px]">
              <p className="text-gray-700 text-base mb-4">
                <p className="text-left">Email: {webShop.webShopContact.contactEmail}</p>
                <p className="text-left">Phone: {webShop.webShopContact.contactPhone}</p>
                <p className="text-left">Company: {webShop.webShopContact.contactCompany}</p>
                <p className="text-left">Street1: {webShop.webShopContact.contactStreet1}</p>
                <p className="text-left">Street2: {webShop.webShopContact.contactStreet2}</p>
                <p className="text-left">ZipCode: {webShop.webShopContact.contactZipCode}</p>
                <p className="text-left">City: {webShop.webShopContact.contactCity}</p>
                <p className="text-left">State: {webShop.webShopContact.contactState}</p>
                <p className="text-left">Country: {webShop.webShopContact.contactCountry}</p>
              </p>
            </div>
          </div>
        )}
        <button type="button" onClick={() => goToHome()} className="mt-[20px] inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out">
          {t('webshop.BACK_TO_START_PAGE')}
        </button>
      </section>
    </div>
  );
}

export const getStaticPaths = async () => {
  return {
    paths: ['/id/support'],
    fallback: true,
  };
};

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['webshop'])),
    },
  };
};

export default IndexPage;
